import styled from 'styled-components';

export const ArrowButton = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.primary.blue};
  border-radius: 2px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  cursor: pointer;
`;

export const SelectWrapper = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    min-width: 100px;
    border: 1px solid ${({ theme }) => theme.colors.primary.blue};
    .ant-select-selection-item {
      color: ${({ theme }) => theme.colors.primary.blue};
    }
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: ${({ theme }) => theme.colors.primary.blue};
    box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.primary.blue}4a;
  }
  .ant-select-arrow {
    width: 20px;
    height: 20px;
    div {
      margin: 0;
    }
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
    padding-right: 25px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  & > div:not(:nth-child(2)) {
    margin-left: 16px;
    :nth-child(4) {
      margin-left: 32px;
    }
    :nth-child(6) {
      margin-left: 12px;
    }
  }
`;
